// export const submitSurvey = (protocolId, surveyId, questionAnswers) => {
// 	return fetch(`/api/survey/${surveyId}`, {
// 		method: 'POST',
// 		headers: { 'content-type': 'application/json' },
// 		body: JSON.stringify({ questionAnswers })
// 	})
// 		.then(function(response) {
// 			if (response.status === 200) {
// 				return response.json()
// 			}
// 		})
// 		.then(function(data) {
// 			return data
// 		})
// }
// incytes-app-30/incytes-ui/src/apis/observationalProtocol.js
export const submitSurvey = (
  caseId,
  protocolId,
  instanceId,
  surveyId,
  patientId,
  questionAnswerSides,
  requestType,
  status,
  editReason,
) => {
  return fetch(
    `/api/survey/${requestType ? requestType + "/" : ""}${caseId}/${protocolId}/${instanceId}/${surveyId}/${patientId}`,
    {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        questionAnswerSides: questionAnswerSides,
        reOpened: status == 2,
        patientId,
        editReason: editReason || null,
      }),
    },
  )
    .then(function (response) {
      if (response.status === 200) {
        return response.json();
      }
    })
    .then(function (data) {
      return data;
    });
};

// Preview propagation
export const previewPropagation = (caseId, corrections) => {
  return fetch(`/api/survey/propagate/preview/${caseId}`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(corrections),
  })
    .then(function (response) {
      if (response.status === 200) {
        return response.json();
      }
      throw new Error("Preview failed");
    })
    .then(function (data) {
      return data;
    });
};

// Preview propagation for task
export const previewPropagationForTask = (taskId, corrections) => {
    return fetch(`/api/survey/task/propagate/preview/${taskId}`, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(corrections),
    })
        .then(function (response) {
            if (response.status === 200) {
                return response.json();
            }
            throw new Error("Preview failed");
        })
        .then(function (data) {
            return data;
        });
};

// Execute propagation
export const propagateCorrections = (caseId, requests) => {
  return fetch(`/api/survey/propagate/${caseId}`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(requests),
  })
    .then(function (response) {
      if (response.status === 200) {
        return response.json();
      }
      throw new Error("Propagation failed");
    })
    .then(function (data) {
      return data;
    });
};

// Execute propagation for task
export const propagateCorrectionsForTask = (taskId, requests) => {
    return fetch(`/api/survey/task/propagate/${taskId}`, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(requests),
    })
        .then(function (response) {
            if (response.status === 200) {
                return response.json();
            }
            throw new Error("Propagation failed");
        })
        .then(function (data) {
            return data;
        });
};

export const changeSurveyCompletedDate = (caseId, instanceId, newDate) => {
  return fetch(`/api/survey/changecompleteddate/${caseId}/${instanceId}`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ date: newDate }),
  })
    .then(function (response) {
      if (response.status === 200) {
        return response.json();
      }
    })
    .then(function (data) {
      return data;
    });
};

export const checkCanResendSurveyReminders = (caseId) => {
  return fetch(`/api/survey/canResendSurveyReminders/${caseId}`, {
    method: "GET",
  })
    .then(function (response) {
      if (response.status === 200) {
        return response.json();
      }
    })
    .then(function (data) {
      return data;
    });
};

export const resendSurveyReminder = (caseId, instanceId) => {
  return fetch(`/api/survey/resendSurveyReminder/${caseId}/${instanceId}`, {
    method: "POST",
  })
    .then(function (response) {
      if (response.status === 200) {
        return response.json();
      }
    })
    .then(function (data) {
      return data;
    });
};
